import { AsyncIterableX } from '../../asynciterable/asynciterablex';
import { defer as deferStatic } from '../../asynciterable/defer';

AsyncIterableX.defer = deferStatic;

declare module '../../asynciterable/asynciterablex' {
  namespace AsyncIterableX { export let defer: typeof deferStatic; }
}



// WEBPACK FOOTER //
// ./node_modules/ix/add/asynciterable/defer.ts